"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTransformer = void 0;
var lodash_isundefined_1 = __importDefault(require("lodash.isundefined"));
var lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));
var lodash_uniq_1 = __importDefault(require("lodash.uniq"));
var lodash_groupby_1 = __importDefault(require("lodash.groupby"));
var HeaderTransformer = /*#__PURE__*/function () {
  function HeaderTransformer(parserOptions) {
    _classCallCheck(this, HeaderTransformer);
    this.headers = null;
    this.receivedHeaders = false;
    this.shouldUseFirstRow = false;
    this.processedFirstRow = false;
    this.headersLength = 0;
    this.parserOptions = parserOptions;
    if (parserOptions.headers === true) {
      this.shouldUseFirstRow = true;
    } else if (Array.isArray(parserOptions.headers)) {
      this.setHeaders(parserOptions.headers);
    } else if (lodash_isfunction_1.default(parserOptions.headers)) {
      this.headersTransform = parserOptions.headers;
    }
  }
  _createClass(HeaderTransformer, [{
    key: "transform",
    value: function transform(row, cb) {
      if (!this.shouldMapRow(row)) {
        return cb(null, {
          row: null,
          isValid: true
        });
      }
      return cb(null, this.processRow(row));
    }
  }, {
    key: "shouldMapRow",
    value: function shouldMapRow(row) {
      var parserOptions = this.parserOptions;
      if (!this.headersTransform && parserOptions.renameHeaders && !this.processedFirstRow) {
        if (!this.receivedHeaders) {
          throw new Error('Error renaming headers: new headers must be provided in an array');
        }
        this.processedFirstRow = true;
        return false;
      }
      if (!this.receivedHeaders && Array.isArray(row)) {
        if (this.headersTransform) {
          this.setHeaders(this.headersTransform(row));
        } else if (this.shouldUseFirstRow) {
          this.setHeaders(row);
        } else {
          // dont do anything with the headers if we didnt receive a transform or shouldnt use the first row.
          return true;
        }
        return false;
      }
      return true;
    }
  }, {
    key: "processRow",
    value: function processRow(row) {
      if (!this.headers) {
        return {
          row: row,
          isValid: true
        };
      }
      var parserOptions = this.parserOptions;
      if (!parserOptions.discardUnmappedColumns && row.length > this.headersLength) {
        if (!parserOptions.strictColumnHandling) {
          throw new Error("Unexpected Error: column header mismatch expected: ".concat(this.headersLength, " columns got: ").concat(row.length));
        }
        return {
          row: row,
          isValid: false,
          reason: "Column header mismatch expected: ".concat(this.headersLength, " columns got: ").concat(row.length)
        };
      }
      if (parserOptions.strictColumnHandling && row.length < this.headersLength) {
        return {
          row: row,
          isValid: false,
          reason: "Column header mismatch expected: ".concat(this.headersLength, " columns got: ").concat(row.length)
        };
      }
      return {
        row: this.mapHeaders(row),
        isValid: true
      };
    }
  }, {
    key: "mapHeaders",
    value: function mapHeaders(row) {
      var rowMap = {};
      var headers = this.headers,
        headersLength = this.headersLength;
      for (var i = 0; i < headersLength; i += 1) {
        var header = headers[i];
        if (!lodash_isundefined_1.default(header)) {
          var val = row[i];
          // eslint-disable-next-line no-param-reassign
          if (lodash_isundefined_1.default(val)) {
            rowMap[header] = '';
          } else {
            rowMap[header] = val;
          }
        }
      }
      return rowMap;
    }
  }, {
    key: "setHeaders",
    value: function setHeaders(headers) {
      var _a;
      var filteredHeaders = headers.filter(function (h) {
        return !!h;
      });
      if (lodash_uniq_1.default(filteredHeaders).length !== filteredHeaders.length) {
        var grouped = lodash_groupby_1.default(filteredHeaders);
        var duplicates = Object.keys(grouped).filter(function (dup) {
          return grouped[dup].length > 1;
        });
        throw new Error("Duplicate headers found ".concat(JSON.stringify(duplicates)));
      }
      this.headers = headers;
      this.receivedHeaders = true;
      this.headersLength = ((_a = this.headers) === null || _a === void 0 ? void 0 : _a.length) || 0;
    }
  }]);
  return HeaderTransformer;
}();
exports.HeaderTransformer = HeaderTransformer;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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